import {
  Toast
} from 'vant';
import Vue from 'vue'
import VueRouter from 'vue-router';
import Home from '../components/AppTabbar.vue';
import load from '../components/load.vue';


const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function (location) {
  return originalPush.call(this, location).catch(err => { })
}

Vue.use(VueRouter)

const routes = [{
  path: '/',
  redirect: "/home"
},
{
  path: '/home',
  name: 'Home',
  component: Home,
},
{
  path: '/message',
  name: 'message',
  component: () => import('@/views/message/index.vue'),
},
{
  path: '/feedback',
  name: 'feedback',
  component: () => import('@/views/feedback/index.vue'),
},
{
  path: '/load',
  name: 'load',
  component: load,
}
]

const router = new VueRouter({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes
})


// 前置路由守卫
router.beforeEach((to, from, next) => {
  // 要去往的路由对象
  // console.log("to", to);
  // 从哪里来的路由
  // console.log("from", from);
  // next放行  可以顺利到达要去的路由



  // 获取登录凭证
  // let token = localStorage.getItem("token");
  let token = '123456';
  if (to.path == "/home") { // 表示去往购物车页面
    // 判断有没有登录,判断token是否存在
    if (token) {
      next()
    } else {
      // 表示没有登录
      Vue.prototype.$toast("请先登录")
      // setTimeout(() => {
      next("/home") // 跳转到user路由
      // }, 1000);
    }
    // return
  }


  next()


})


export default router